import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200/60">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 py-6 flex items-center gap-4">
          <Link to="/" data-testid="terms-back-link" className="text-slate-500 hover:text-slate-900 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-emerald-500 flex items-center justify-center">
              <Shield className="w-3.5 h-3.5 text-white" />
            </div>
            <span className="font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>CrediAcceso</span>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 sm:px-8 py-12">
        <h1
          data-testid="terms-title"
          className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-8"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Terminos y Condiciones
        </h1>

        <div className="bg-white rounded-3xl border border-slate-200/60 shadow-sm p-8 md:p-12 space-y-8 text-sm text-slate-600 leading-relaxed">
          <p className="text-xs text-slate-400">Ultima actualizacion: Diciembre 2025</p>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Identificacion del prestador</h2>
            <p>
              CrediAcceso es una marca comercial de <strong>RECAUDACIONES Y COBRANZAS LIMITADA</strong>, RUT 96.754.900-2,
              con domicilio en Santo Domingo 628, Santiago, Region Metropolitana, Chile. La empresa actua como intermediario
              financiero, conectando a los clientes con entidades financieras autorizadas, y no otorga creditos directamente.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Naturaleza del servicio</h2>
            <p>
              CrediAcceso facilita la conexion entre personas naturales o juridicas que buscan financiamiento y entidades
              financieras que ofrecen productos crediticios. No somos una institucion financiera, banco ni cooperativa de ahorro
              y credito. No captamos depositos ni otorgamos creditos de forma directa.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Uso del sitio web</h2>
            <p>
              Al utilizar este sitio web, el usuario acepta estos terminos y condiciones en su totalidad. El uso del sitio esta
              destinado exclusivamente a personas mayores de 18 anios con capacidad legal para contratar.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Proceso de solicitud</h2>
            <p>
              El usuario podra completar un formulario de simulacion indicando el monto deseado, tipo de cliente y datos personales
              basicos. Esta informacion sera utilizada exclusivamente para evaluar opciones crediticias con las entidades financieras
              asociadas. El envio del formulario no constituye una solicitud formal de credito ni garantiza la aprobacion del mismo.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Evaluacion crediticia</h2>
            <p>
              Toda solicitud de credito esta sujeta a evaluacion crediticia por parte de la entidad financiera correspondiente.
              CrediAcceso no tiene incidencia en la decision de aprobacion o rechazo. Las condiciones finales del credito
              (tasa, plazo, monto aprobado) seran determinadas por la entidad financiera en base al perfil del solicitante.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Informacion referencial</h2>
            <p>
              Las tasas, montos y plazos publicados en el sitio son referenciales y pueden variar segun el perfil crediticio
              del solicitante y las condiciones de cada entidad financiera. CrediAcceso no garantiza que las condiciones
              finales coincidan con los valores referenciales mostrados.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Proteccion de datos</h2>
            <p>
              Los datos personales proporcionados seran tratados conforme a nuestra Politica de Privacidad y la legislacion
              chilena vigente sobre proteccion de datos personales (Ley 19.628). Para mas informacion, consulte nuestra{" "}
              <Link to="/privacidad" className="text-emerald-600 underline hover:text-emerald-700">Politica de Privacidad</Link>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Limitacion de responsabilidad</h2>
            <p>
              CrediAcceso no sera responsable por las decisiones de credito tomadas por las entidades financieras asociadas,
              ni por las condiciones finales de los productos crediticios ofrecidos. Tampoco sera responsable por danos directos
              o indirectos derivados del uso de este sitio web.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>9. Modificaciones</h2>
            <p>
              CrediAcceso se reserva el derecho de modificar estos terminos y condiciones en cualquier momento. Las
              modificaciones seran publicadas en este sitio web y entraran en vigor desde su publicacion.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Legislacion aplicable</h2>
            <p>
              Estos terminos y condiciones se rigen por la legislacion de la Republica de Chile. Cualquier controversia sera
              sometida a los tribunales ordinarios de justicia de la ciudad de Santiago.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
